import {
  WIDTH as WIDTHPdf,
  HEIGHT as HEIGHTPdf,
  fontSize,
  PADDING,
} from '../constants'

const numberPage = (
  pdf,
  color,
  customThemeStatus = false,
  skippedPages = 2,
) => {
  const adjustedSkippedPages = customThemeStatus ? 1 : skippedPages
  const WIDTH = WIDTHPdf(pdf)
  const HEIGHT = HEIGHTPdf(pdf)
  const PAGE_NUMBER =
    pdf.internal.getCurrentPageInfo().pageNumber - adjustedSkippedPages

  pdf.setFont('Raleway-Bold')
  pdf.setFontSize(fontSize.pageNumber)
  pdf.setTextColor(color)
  pdf.text(PAGE_NUMBER.toString(), WIDTH - PADDING, HEIGHT - PADDING / 2)
}

export default numberPage
